import React from 'react';
import styled, { keyframes } from 'styled-components';
import breakpoints from 'theme/breakpoints';
import additionalSections from './additionalSections';
import AdditionalHubCard from './AdditionalHubCard';

export default function AdditionalHub({ summaryData, onSelectSection }) {
    return (
        <Grid>
            {additionalSections.map((section) => (
                <AdditionalHubCard
                    key={section.key}
                    icon={section.icon}
                    title={section.title}
                    description={section.description}
                    badge={section.getBadge(summaryData)}
                    comingSoon={section.comingSoon}
                    onClick={() => onSelectSection(section.key)}
                />
            ))}
        </Grid>
    );
}

const fadeIn = keyframes`
    from { opacity: 0; transform: translateY(8px); }
    to { opacity: 1; transform: translateY(0); }
`;

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
    animation: ${fadeIn} 0.3s ease-out;

    @media screen and (min-width: ${breakpoints.sm}) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media screen and (min-width: ${breakpoints.lg}) {
        grid-template-columns: repeat(3, 1fr);
    }
`;
